import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=a045a45c&scoped=true&"
import script from "./chatInput.vue?vue&type=script&lang=js&"
export * from "./chatInput.vue?vue&type=script&lang=js&"
import style0 from "./chatInput.vue?vue&type=style&index=0&id=a045a45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045a45c",
  null
  
)

export default component.exports